
import CardPropertyObjectTable from '../../components/Card/CardPropertyObjectTable.vue'

export default {
  name: 'ProjectPropertyOrganizations',
  extends: CardPropertyObjectTable,
  computed: {
    columns: function () {
      const columnsProps = [
        { name: 'name', label: 'Название', type: 'string' },
        {
          name: 'detailedDebits',
          label: 'РУ',
          type: 'boolean',
          sortable: false,
          componentProps: {
            labelTooltip: 'Раздельный учет',
            autoWidth: true,
            tdStyle: this.getBooleanTdStyle.bind(this)
          }
        },
        {
          name: 'ignoreLimits',
          label: 'ПО',
          type: 'boolean',
          sortable: false,
          componentProps: {
            labelTooltip: 'Разрешено превышение остатков на складах',
            autoWidth: true,
            tdStyle: this.getBooleanTdStyle.bind(this)
          }
        }
      ]

      const componentProps = this.tabProp.componentProps
      if (componentProps.showRelationship) {
        columnsProps.push({
          name: 'showRelationship',
          label: '',
          type: '_btn',
          sortable: false,
          componentProps: {
            tooltip: 'Открыть карточку связи',
            onClick: this.onShowRelationship,
            icon: 'mdi-card-bulleted-outline'
          }
        })
        columnsProps.push({
          name: 'showObject',
          label: '',
          type: '_btn',
          sortable: false,
          componentProps: {
            tooltip: 'Открыть карточку объекта',
            onClick: (row, event) => this.showObjectCard(event, row),
            icon: 'mdi-text-box-outline'
          }
        })
      }
      return columnsProps.map(o => this.getColumnConfig(o))
    }
  },
  methods: {
    getBooleanTdStyle: function (col, row) {
      const value = row[col.field]
      if (value === true) {
        return this.getColoredTdStyle('rgba(0, 255, 0, 0.3)', 'black')
      } else if (value == false) {
        return this.getColoredTdStyle('rgba(255, 0, 0, 0.3)', 'black')
      }
      return null
    },
    getColoredTdStyle: function (bgColor, color, fontWeight = 400) {
      if (bgColor == null) {
        bgColor = 'white'
        color = 'black'
      }
      return `font-weight: ${fontWeight} !important;
          background-color: ${bgColor} !important;
          color: ${color} !important;
          border-bottom: solid #e0e0e0 1px;`
    }
  }
}
